module.exports = __webpack_public_path__ + "img/1440987166.f0027c14.jpg";